module.exports = __webpack_public_path__ + "img/nonehead.4eb287bf.png";